/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Insert_Event_BelowInputs */



/**
* | output |
* | --- |
* | "Insert Event (Below)" |
*
* @param {Shortcut_Keys_Name_Insert_Event_BelowInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_insert_event_below = /** @type {((inputs?: Shortcut_Keys_Name_Insert_Event_BelowInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Insert_Event_BelowInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inserer un evenement (en dessous)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis einfügen (unten)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci evento (sotto)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить событие (ниже)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar evento (abajo)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入事件（如下）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントを挿入（下）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट डालें (नीचे)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir evento (abaixo)")
	return /** @type {LocalizedString} */ ("Insert Event (Below)")
});